import useAppDispatch from '../../../hooks/useAppDispatch';
import useAppSelector from '../../../hooks/useAppSelector';
import { useTranslation } from '../../../hooks/useTranslation';
import { dispatchEvent } from '../../../services/EventService';
import { getConnector } from '../../../services/Connector';
import IconButton from '../../button/IconButton';
import './AssistantHeaderButtons.less';

const AssistantHeaderButtons = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const isSidebarExpanded = useAppSelector(
        state => state.featureState.sidebarExpanded
    );
    const totalQuantity = useAppSelector(
        state => state.cartState.currentCart.totalQuantity
    );
    return (
        <div className={`bri-AssistantHeaderButtons`}>
            <div className="bri-AssistantHeaderButtons-cart">
                <IconButton
                    size="large"
                    variant="primary"
                    iconId="cart"
                    title={t('GO_TO_CART')}
                    onClick={() => {
                        getConnector().goToCart();
                        dispatchEvent({
                            type: 'bri.click_go_to_cart',
                            isInteraction: true
                        });
                    }}
                />
                {totalQuantity > 0 && (
                    <div className="bri-AssistantHeaderButtons-cart-total-quantity">
                        {totalQuantity}
                    </div>
                )}
            </div>
            <IconButton
                size="large"
                variant="primary"
                iconId={isSidebarExpanded ? 'chat-on' : 'chat-off'}
                title={t(isSidebarExpanded ? 'CLOSE_CHAT' : 'OPEN_CHAT')}
                className="bri-AssistantHeaderButtons-chat"
                onClick={() =>
                    dispatch.featureState.setSidebarExpanded(!isSidebarExpanded)
                }
            />
            <IconButton
                size="large"
                variant="primary"
                iconId="home"
                title={t('HOME')}
                className="bri-AssistantHeaderButtons-home"
                onClick={() => {
                    dispatch.uiState.setMode('menu');
                    dispatch.featureState.reset();
                    dispatch.productsGridState.reset();
                    dispatchEvent({
                        type: 'bri.close_main_window',
                        isInteraction: true
                    });
                }}
            />
            <IconButton
                size="large"
                variant="primary"
                iconId="close"
                title={t('CLOSE')}
                className="bri-AssistantHeaderButtons-close"
                onClick={() => dispatch.uiState.setMode('button')}
            />
        </div>
    );
};

export default AssistantHeaderButtons;
